import { render, staticRenderFns } from "./CustomActivityPromotionDialog.vue?vue&type=template&id=0e96d5b1&scoped=true"
import script from "./CustomActivityPromotionDialog.vue?vue&type=script&lang=js"
export * from "./CustomActivityPromotionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96d5b1",
  null
  
)

export default component.exports